import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { useDebugModeEnabled } from './useDebugModeEnabled';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncDebugModeCard = Loadable({
  loader: () => import('./DebugModeCard'),
  LoadingComponent: () => null
});
const DebugModeCardContainer = () => {
  const debugModeEnabled = useDebugModeEnabled();
  if (!debugModeEnabled) {
    return null;
  }
  return /*#__PURE__*/_jsx(AsyncDebugModeCard, {});
};
export default DebugModeCardContainer;